// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1820":"e5073c60","3663":"ea37adf7","5614":"0aafa91b","6921":"e53397af","8327":"599680f1","9765":"599680f1"}[chunkId] + ".css";
};